import {
  TModelValueType,
} from './input-qmulus-dashboard-widget-threshold-value.ts';

const modelValueType: Record<TModelValueType, string> = {
  value: 'Static',
  factoredLimit: 'Dynamic',
  limitMin: 'Axis minimum',
  limitMax: 'Axis maximum',
  infinity: '+∞',
};

export default {
  modelValueType,
};
